import { Button } from '@up2stay/up2promo-ui';
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { captureException } from '@/core/posthog-init';

function RootFallback() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background p-6">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 text-center">
        <img
          src="/assets/images/brand/logo.svg"
          alt="up2promo"
          className="h-20 object-contain"
        />
        <div className="flex flex-col gap-2">
          <p className="text-lg font-semibold text-foreground">
            Something went wrong
          </p>
          <p className="text-sm text-foreground/70">
            An unexpected error occurred. Please reload the page to continue.
          </p>
        </div>
        <Button className="w-full" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </div>
    </div>
  );
}

type RootErrorBoundaryProps = {
  children: ReactNode;
};

type RootErrorBoundaryState = {
  hasError: boolean;
};

export class RootErrorBoundary extends Component<
  RootErrorBoundaryProps,
  RootErrorBoundaryState
> {
  constructor(props: RootErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): RootErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureException(error, {
      errorBoundary: true,
      componentStack: errorInfo.componentStack ?? undefined,
    });
  }

  render() {
    if (this.state.hasError) {
      return <RootFallback />;
    }
    return this.props.children;
  }
}
